import React, { useRef, useEffect } from 'react';

interface ControlledVideoProps {
  src: string;
  playing: boolean;
  poster?: string;
}

export default function ControlledVideo({ src, playing, poster }: ControlledVideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;

    // 1) Asegúrate de que esté mutuado y playsInline
    v.muted = true;
    v.playsInline = true;
    
    // 2) Configurar preload para mejor rendimiento en Raspberry Pi
    v.preload = 'auto';
    
    // 3) Forzar hardware acceleration
    v.style.transform = 'translateZ(0)';
    v.style.willChange = 'transform';
    v.style.backfaceVisibility = 'hidden';
    v.style.webkitBackfaceVisibility = 'hidden';

    // 4) Espera a que cargue "suficiente" antes de reproducir o pausar
    const onCanPlay = () => {
      if (playing) {
        v.play().catch((e) => console.warn('Play rechazado:', e));
      } else {
        v.pause();
      }
    };

    v.addEventListener('canplay', onCanPlay);
    // dispara manualmente por si ya estaba listo
    if (v.readyState >= 3) onCanPlay();

    return () => {
      v.removeEventListener('canplay', onCanPlay);
    };
  }, [playing]);

  return (
    <video
      ref={videoRef}
      src={src}
      poster={poster}
      className="w-full h-full"
      loop={true}
      muted={true}
      playsInline={true}
      preload="auto"
      controls={false}
      autoPlay={playing}
      style={{
        transform: 'translateZ(0)',
        willChange: 'transform',
        backfaceVisibility: 'hidden',
        WebkitBackfaceVisibility: 'hidden',
      }}
    />
  );
}
